// extracted by css-extract-rspack-plugin
export default {"salaryAdviceTooltip":"salary-advice-tooltip--xZ2WyqQ3X0Exsnld"};